import React from 'react';
import PropTypes from 'prop-types';
import ChairRentalListItem from '../containers/ChairRentalListItem';
import { chairRentalShape } from '../shapes';

const ChairRentalList = ({ chairRentals }) => (
  <div className="s-v2">
    <div className="c-table-card c-table-new">
      <div className="c-table-card__head">
        <div className="c-table-card__cell u-1/12 u-pl0">
          <div className="c-label-new">Auto charge rent</div>
        </div>
        <div className="c-table-card__cell u-3/12">
          <div className="c-label-new">Barber</div>
        </div>
        <div className="c-table-card__cell u-visible-table-cell-for-large-and-up u-1/12">
          <div className="c-label-new">Overdue</div>
        </div>
        <div className="c-table-card__cell u-visible-table-cell-for-large-and-up u-1/12">
          <div className="c-label-new">Next payment</div>
        </div>
        <div className="c-table-card__cell u-visible-table-cell-for-large-and-up u-1/12">
          <div className="c-label-new">Total due</div>
        </div>
        <div className="c-table-card__cell u-visible-table-cell-for-large-and-up u-1/12">
          <div className="c-label-new">Due date</div>
        </div>
        <div className="c-table-card__cell u-1/12" />
      </div>

      {chairRentals.map(chairRental =>
        <ChairRentalListItem chairRental={chairRental} key={`chair-rental-${chairRental.barberId}`} />
      )}
    </div>
  </div>
);

ChairRentalList.propTypes = {
  chairRentals: PropTypes.arrayOf(chairRentalShape),
};

ChairRentalList.defaultProps = {
  chairRentals: [],
};

export default ChairRentalList;
